import TagManager from 'react-gtm-module';

class GTManager {
    init() {
        const tagManagerArgs = {
            gtmId: 'GTM-TBDTXC6',
        };

        if (process.env.REACT_APP_STAGE === 'prod') {
            TagManager.initialize(tagManagerArgs);
        }
    }

    update(data) {
        const userFromLocalStorage = JSON.parse(localStorage.getItem('user'));
        localStorage.setItem(
            'user',
            JSON.stringify({
                ...userFromLocalStorage,
                ...data,
                token: data.token || userFromLocalStorage.token,
            }),
        );
        this.push('user-data-updated');
    }

    push(event) {
        window.dataLayer?.push({ event });
    }
}

export default new GTManager();
